import script from "./infraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./infraModal.vue?vue&type=script&setup=true&lang=js"

import "./infraModal.vue?vue&type=style&index=0&id=b2b3be9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2b3be9a"]])

export default __exports__